import React from 'react';

const TenantUserMappingFormModal = React.lazy(() => import('../components/FormModal'));
const tenantUserMappingModalRegistry = {
    core_tenantUserMappingId: TenantUserMappingFormModal
};
export default tenantUserMappingModalRegistry;
